<template>
  <div class="question-card">
    <div v-if="!hideTitle" class="question-card__title">
      <slot name="title"></slot>
    </div>
    <form @submit.prevent="emitSubmit">
      <div class="question-card__content">
        <slot></slot>
      </div>
      <div
        v-if="!hideButton"
        class="question-card__next md-layout md-alignment-center-center"
      >
        <div class="md-layout-item question-card__button-wrapper">
          <v-button
            type="submit"
            class="question-card__button"
            :disabled="disabled"
          >
            <span>{{buttonText}}</span>
            <v-icon>keyboard_backspace</v-icon>
          </v-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import VButton from '@/components/ui-kit/VButton.vue';
export default {
  name: "question-card",
  components: {
    VButton,
  },
  props: {
    disabled: {
      type: Boolean,
    },
    hideButton: {
      type: Boolean,
    },
    hideTitle: {
      type: Boolean,
    },
    buttonText: {
      type: String,
    },
  },
  methods: {
    emitSubmit(event) {
      this.$emit("submit", event);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
@import "~@/styles/mixins";

.question-card {
  font-family: "Avenir Next";
  border-radius: 6px;
  background: $table-grey;
  border: 1px solid $border-grey;
  padding: 30px;
  width: calc(100vw - 20px);;
  max-width: 750px;

  .answer-item {

    &_checked {
      @include checked-mark;
      &::after{
        position: absolute;
      }
    }

  }

  &__title {
    color: $matterhorn;
    text-align: center;
    margin-bottom: 30px;
    line-height: 50px;
    font: {
      weight: 500;
      size: 40px;
    }
  }

  &__next {
    margin-top: 30px;
  }

  &__button {
    height: 60px;
    width: 225px;
    border-radius: 35px;
    letter-spacing: 1.5125px;
    font: {
      family: "Roboto";
      weight: 500;
      size: 14px;
    }

    span {
      vertical-align: middle;
      color: $white;

    }

    .v-icon.material-icons {
      color: $white;
      padding-right: 15px;
      transform: rotate(180deg);
    }

    &-wrapper {
      text-align: center;
    }
  }

  background: none;
  border: none;

  &__title {
    font-size: 28px;
    line-height: 29px;
  }

  &__next {
    flex-direction: column;
    text-align: center;
  }
}
</style>
